import * as Scorm2004Api from "../2004/api2004";
import {AllScos2004Data} from "../2004/api2004";
import {Manifest, ScoNavItem} from "../scorm/manifest";
import {ScormPluginBase} from "../scorm/plugin";
import {Manifest2004, ScoNavItem2004} from "../2004/manifest2004";
import {Request, RequestCategory, SequencingProcess2004Simple} from "./sn";
import {initializeApiShared} from "../2004/pluginshared";
import {SSLAApiEvents} from "../scorm/events";
import {NavActions} from "../scorm/sn";

export {UrlVarService} from "../url";

declare var reqwest: any;


export class Scorm2004SimplePlugin extends ScormPluginBase {
    public API_1484_11: Scorm2004Api.Scorm2004Api = null;
    public sequencing: SequencingProcess2004Simple = null;

    constructor(events: SSLAApiEvents=null) {
        super(events);
        // TODO Can we register this as a callback instead of using the public events system?
        //   We want to avoid users being able to remove it, or having it execute in the wrong order.
        this.events.postFinish.add(this.maybeNavigateDueToTerminate, this);
    }

    attemptSequencing(): string {
        if (this.nextScoAction) {
            return this.sequencing.do(new Request(RequestCategory.Navigation, this.nextScoAction, this.nextScoTarget));
        }
        return "";
    }

    createManifestClass(): Manifest {
        let man: Manifest;
        if (this.mvc.lastError != "") {
            return null;
        }

        if (this.mvc.schemaVersionMain == "2004") {
            man = new Manifest2004();
        }
        else {
            throw new Error("Manifest is for an unsupported SCORM version: " + this.mvc.schemaVersionMain);
        }
        man.schemaVersionMain = this.mvc.schemaVersionMain;
        man.schemaVersionSub = this.mvc.schemaVersionSub;
        man.rawManifest = this.mvc.rawManifest;
        return man;
    }

    initializeApi(scoNav: ScoNavItem) {
        let i = this.scosData.scos[scoNav.identifier];
        initializeApiShared(i, scoNav, this.config);
        this.API_1484_11 = new Scorm2004Api.Scorm2004Api(scoNav.identifier,
            (<Scorm2004Api.Sco2004Data>this.scosData.scos[scoNav.identifier]), this.events, this.config,
            Object.keys(this.manifest.scosByIdentifiers),
            this.manifest.navigableScoPreOrderTraversal.map(x => x.identifier),
            scoNav as ScoNavItem2004);
        this.API_1484_11.addSaveCallback(this.storage.save, this.storage);
        (<any>window).API_1484_11 = this.API_1484_11;
        if (this.config.initializeScoAtOpen()) {
            this.API_1484_11.Initialize("");
        }
    }

    endPreviousSco() {
        // If there's anything already open, close it.
        // And don't re-end an already ended SCO.
        if (this.currentSco && this.API_1484_11 && !this.API_1484_11.sco.end) {
            this.API_1484_11.Terminate("");
        }
    }

    initializeScosData() {
        let i: number;
        // Now that we know the version, build the data structure that uses it.
        this.scosData = new Scorm2004Api.AllScos2004Data();
        for (i = 0; i < this.manifest.scoPreOrderTraversal.length; i++) {
            this.scosData.scos[this.manifest.scoPreOrderTraversal[i].identifier] = new Scorm2004Api.Sco2004Data();
        }
    }

    initializeSequencing() {
        this.nextScoAction = null;
        this.nextScoTarget = "";
        this.sequencing = new SequencingProcess2004Simple(this.manifest as Manifest2004, this.scosData as AllScos2004Data);

        // When attempting to return to last SCO on launch,
        // verify that the current SCO ID still exists in the version of the course that's trying to be loaded.
        // If it doesn't, we must fall through to a normal default launch.
        if (this.config.returnToLastActivityOnLaunch() && this.scosData.currentScoId && this.manifest.scosByIdentifiers[this.scosData.currentScoId]) {
            this.nextScoAction = NavActions.Choice;
            this.nextScoTarget = this.scosData.currentScoId;
        }
        else if (this.config.autoLaunchFirstSco()) {
            this.nextScoAction = NavActions.Start;
            this.nextScoTarget = "";
        }

        if (this.nextScoAction) {
            this.attemptNavigate();
        }
    }

    maybeNavigateDueToTerminate() {
        let adlNavReq = <string>this.scosData.scos[this.currentSco.identifier].get("adl.nav.request");
        if (adlNavReq != "") {
            // adl.nav.request cannot override an explicitly chosen user action.
            if (!this.nextScoAction) {
                this.navigateDueToTerminate(adlNavReq);
            }
        }
    }

    navigate(type: string) {
        if (type === "next") {
            this.nextScoAction = NavActions.Continue;
            this.nextScoTarget = "";
        }
        else if (type === "previous") {
            this.nextScoAction = NavActions.Previous;
            this.nextScoTarget = "";
        }
        else if (type === "repeat") {
            this.nextScoAction = NavActions.Choice;
            this.nextScoTarget = this.currentSco.identifier;
        }

        if (this.nextScoAction) {
            this.attemptNavigate();
        }
    }

    navigateDueToTerminate(adlNavReq: string) {
        let navable = false;
        if (adlNavReq === "continue") {
            this.nextScoAction = NavActions.Continue;
            this.nextScoTarget = "";
            navable = true;
        }
        else if (adlNavReq === "previous") {
            this.nextScoAction = NavActions.Previous;
            this.nextScoTarget = "";
            navable = true;
        }
        else if (adlNavReq.match(/^\{target=(.+)\}choice$/)) {
            let adlMatch = adlNavReq.match(/^\{target=(.+)\}choice$/);
            this.nextScoAction = NavActions.Choice;
            this.nextScoTarget = adlMatch[1];
            navable = true;
        }
        else if (adlNavReq.match(/^\{target=(.+)\}jump$/)) {
            let adlMatch = adlNavReq.match(/^\{target=(.+)\}jump$/);
            this.nextScoAction = NavActions.Choice;
            this.nextScoTarget = adlMatch[1];
            navable = true;
        }
        else if (adlNavReq === "exit") {
            // TODO
        }
        else if (adlNavReq === "exitAll") {
            // TODO
        }
        else if (adlNavReq === "abandon") {
            // TODO
        }
        else if (adlNavReq === "abandonAll") {
            // TODO
        }
        else if (adlNavReq === "suspendAll") {
            // TODO
        }

        if (navable) {
            this.attemptNavigate();
        }
    }

    navigateByIdentifier(id: string) {
        this.nextScoAction = NavActions.Choice;
        this.nextScoTarget = id;
        this.attemptNavigate();
    }
}

